import { z } from "zod";
import { intl } from "LocaleWrapper";

z.config({
	customError: (issue) => {
		if (issue.code === "invalid_type") {
			return intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" });
		}

		if (issue.origin === "string" && issue.code === "too_small") {
			return intl.formatMessage({ id: "ZOD_VALIDATION_TEXT_TOO_SMALL" }).replace("_X_", `${issue.minimum ?? 0}`);
		}

		if (issue.origin === "string" && issue.code === "too_big") {
			return intl.formatMessage({ id: "ZOD_VALIDATION_TEXT_TOO_BIG" }).replace("_X_", `${issue.maximum ?? 0}`);
		}

		if (issue.origin === "number" && issue.code === "too_small") {
			return intl.formatMessage({ id: "ZOD_VALIDATION_NUMBER_TOO_SMALL" }).replace("_X_", `${issue.minimum ?? 0}`);
		}

		if (issue.origin === "number" && issue.code === "too_big") {
			return intl.formatMessage({ id: "ZOD_VALIDATION_NUMBER_TOO_BIG" }).replace("_X_", `${issue.maximum ?? 0}`);
		}

		if (issue.format === "email" && issue.code === "invalid_format") {
			return intl.formatMessage({ id: "VALIDATION_EMAIL" });
		}

		return intl.formatMessage({ id: "INVALID" });
	},
});
